/** Production world adapter around the reusable authority/prediction movement step. */
import { clampWorldPosition } from "./world-generation.js";
import { sampleWorldWaterAt } from "./water.js";
import { stepPlayerLocomotion as step } from "./player-locomotion.js";
export * from "./player-locomotion.js";
export function stepPlayerLocomotion(state, input, deltaSeconds, options) {
    return step(state, input, deltaSeconds, { ...options, sampleWater: options.sampleWater ?? sampleWorldWaterAt, clampPosition: clampWorldPosition });
}
